import { GridConfig } from '@inavista/components/grid';

// Direct Reports popup (Users page) on @inavista/components. Rows: RIMS Master api/grid/users/direct-reports?app=&userId=
// (dbo.spGetDirectReportsForUserId's rows, paged in SQL; only for a user the caller's Users list shows). Same columns and
// search as the Syncfusion grid it replaces (20-row pages, now one scrolling list).

const COLUMNS = ['employeeId', 'name', 'role', 'application', 'email', 'mobile', 'serviceDepartment', 'district', 'region'];

export function directReportsGridConfig(masterApiUrl: string, app: 'service' | 'sales', userId: string, canExport: boolean): GridConfig {
  return {
    apiBaseUrl: `${masterApiUrl}grid/users/direct-reports`,
    queryParams: { app, userId },
    keyColumn: 'userId',
    clientSide: false,
    pageSize: 200,
    rowHeight: 26,
    loadingIndicator: 'banner',
    stretchColumns: true,
    wrapHeaders: true,
    enableSearch: true,
    enableContextMenuFilter: true,
    enableFitColumns: true,
    enableResetLayout: true,
    enableExport: canExport,
    defaultColumnOrder: COLUMNS,
    hiddenByDefaultColumns: ['userId'],
    defaultSort: { column: 'name', direction: 'asc' },
    columnLabels: {
      employeeId: 'Employee Id', name: 'Name', role: 'Role', application: 'Application', email: 'Email', mobile: 'Contact',
      serviceDepartment: 'Service Department', district: 'District', region: 'Region',
    },
    columnWidths: Object.fromEntries(COLUMNS.map(c => [c, 120])),
    columnAlign: Object.fromEntries(COLUMNS.map(c => [c, {
      header: { horizontal: 'left' as const },
      ...(c === 'employeeId' ? { horizontal: 'center' as const } : {}),
    }])),
    excelFilterColumns: ['application'],
    emptyStateMessage: 'This user has no direct reports.',
    persistenceKey: 'rims.users.direct-reports',
    persistenceVersion: 1,
  };
}
